import React from 'react';
import styled from 'styled-components';
const RecruitPro = () => {
  return (
    <RecruitWrapper>
      <div className="head">
        <span>|| In Steps</span>
        <h1>Recruitment Process</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis
          consectetur delectus unde amet possimus labore.
        </p>
      </div>
      <StepsWrapper>
        <FirstSteps>
          <div className="step">
            <div className="ti">
              <span>1.</span>
              <h1>Resume Submission</h1>
            </div>
            <div className="cap">
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Doloribus libero porro quis sint repellat delectus, inventore
                aut. Soluta a natus, aliquam officia quia culpa veritatis!
              </p>
            </div>
          </div>
          <div className="step">
            <div className="ti">
              <span>2.</span>
              <h1>Invitation To Virtual Interview</h1>
            </div>
            <div className="cap">
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Doloribus libero porro quis sint repellat delectus, inventore
                aut. Soluta a natus, aliquam officia quia culpa veritatis!
              </p>
            </div>
          </div>
        </FirstSteps>
        <SecSteps>
          <div className="step">
            <div className="ti">
              <span>3.</span>
              <h1>Email & Phone Call From HeadStaff </h1>
            </div>
            <div className="cap">
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Doloribus libero porro quis sint repellat delectus, inventore
                aut. Soluta a natus, aliquam officia quia culpa veritatis!
              </p>
            </div>
          </div>
          <div className="step">
            <div className="ti">
              <span>4.</span>
              <h1>Deep Dive Checkup Projects</h1>
            </div>
            <div className="cap">
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Doloribus libero porro quis sint repellat delectus, inventore
                aut. Soluta a natus, aliquam officia quia culpa veritatis!
              </p>
            </div>
          </div>
        </SecSteps>
      </StepsWrapper>
    </RecruitWrapper>
  );
};

const RecruitWrapper = styled.section`
  min-height: 100vh;
  padding: 100px 20px;
  .head {
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;

    span {
      color: var(--bg-color);
      font-weight: 700;
    }

    h1 {
      color: var(--bg-color);
      font-size: 2.8rem;
      font-weight: 700;
      padding: 10px 0;
    }
    p {
      color: var(--text-color);
      font-size: 1.06rem;
      font-weight: 600;
      max-width: 520px;
      line-height: 1.7;
    }
  }
  @media screen and (max-width: 768px) {
    .head {
      width: 98%;
    }
  }
  @media screen and (max-width: 430px) {
    .head {
      width: 100%;
      h1 {
        font-size: 2.3rem;
        padding: 12px 0;
      }
    }
  }
`;

const StepsWrapper = styled.article`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
  margin-top: 2%;

  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48vh;
    border-radius: 0.2rem;
    box-shadow: 0 0 10px rgba(15, 11, 197, 0.116);
    padding: 10px;
    text-align: center;

    .ti {
      display: flex;
      align-items: center;
      gap: 1rem;
      span {
        color: var(--ico-color);
        font-size: 3rem;
        font-weight: 700;
      }
      h1 {
        color: var(--bg-color);
        font-size: 1.6rem;
        font-weight: 700;
        padding: 10px 0;
      }
    }
    .cap {
      padding: 15px;
      p {
        font-size: 20px;
        line-height: 1.7;
        color: var(--text-color);
      }
    }
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    .step {
      .ti {
        span {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 430px) {
    grid-template-columns: 1fr;
    .step{
        padding: 0;
        .ti{
            h1{
                font-size: 1.4rem;
            }
        }
        .cap{
          p{
             font-size: 18px;
          }
        }
    }
  }
`;

const FirstSteps = styled.div`
  height: 85vh;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const SecSteps = styled(FirstSteps)``;

export default RecruitPro;
